export enum EnumOrdenacaoUsuario {
    NomeAsc = 1,
    NomeDesc = 2,
    EmailAsc = 3,
    EmailDesc = 4,
  }